/* GOG Edizioni – comportamento del sito su Shopify */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Drawer */
  var drawer = $('.drawer'), drawerBackdrop = $('.drawer-backdrop'), burger = $('.burger-menu');
  function toggleDrawer(open) {
    if (!drawer) return;
    open = typeof open === 'boolean' ? open : !drawer.classList.contains('open');
    drawer.classList.toggle('open', open);
    drawerBackdrop && drawerBackdrop.classList.toggle('open', open);
    burger && burger.classList.toggle('isOpen', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  }
  burger && burger.addEventListener('click', function () { toggleDrawer(); });
  $$('.close-drawer, .drawer-backdrop').forEach(function (el) { el.addEventListener('click', function () { toggleDrawer(false); }); });

  /* Ricerca */
  var sc = $('.search-container'), sb = $('.search-backdrop'), si = $('.search-input'), sr = $('.search-results');
  function toggleSearch(open) {
    if (!sc) return;
    sc.classList.toggle('open', open);
    sb && sb.classList.toggle('open', open);
    if (open) setTimeout(function () { si && si.focus(); }, 50);
  }
  $$('.nav-item.search').forEach(function (el) { el.addEventListener('click', function () { toggleSearch(true); }); });
  $$('.close-search, .search-backdrop').forEach(function (el) { el.addEventListener('click', function () { toggleSearch(false); }); });
  sc && sc.addEventListener('click', function (e) { if (e.target === sc) toggleSearch(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { toggleSearch(false); toggleDrawer(false); } });
  var searchTimer, lastQ = '';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function euro(v) { var n = parseFloat(v); return isNaN(n) ? '' : n.toFixed(2).replace('.', ',') + ' €'; }
  si && si.addEventListener('input', function () {
    clearTimeout(searchTimer);
    var q = si.value.trim();
    searchTimer = setTimeout(function () {
      if (q.length < 2) { sr.classList.remove('open'); sr.innerHTML = ''; return; }
      lastQ = q;
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (q !== lastQ) return;
          var items = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!items.length) { sr.innerHTML = '<p>Nessun risultato per “' + esc(q) + '”.</p>'; sr.classList.add('open'); return; }
          sr.innerHTML = items.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=200' : (p.image || '');
            return '<div class="product-search-card"><a href="' + esc(p.url) + '">' +
              '<div class="image">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</div>' +
              '<div class="detail"><h3>' + esc(p.title) + '</h3><span>' + esc(p.vendor) + (p.price ? ' — ' + euro(p.price) : '') + '</span></div>' +
              '</a></div>';
          }).join('') + '<a class="search-all" href="' + root + 'search?type=product&q=' + encodeURIComponent(q) + '">Vedi tutti i risultati</a>';
          sr.classList.add('open');
        }).catch(function () {});
    }, 200);
  });

  /* Carrello AJAX */
  var toastBox = $('#toast');
  function toast(msg, withAction) {
    if (!toastBox) return;
    var t = document.createElement('div');
    t.className = 'toast' + (withAction ? '' : ' autohide');
    t.innerHTML = (withAction ? '<div class="action"><a class="button sm solid primary" href="' + root + 'cart">Vai al carrello</a></div>' : '') + '<div class="msg">' + msg + '</div>';
    toastBox.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('open'); });
    setTimeout(function () { t.classList.remove('open'); setTimeout(function () { t.remove(); }, 400); }, 4000);
  }
  function updateCount() {
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      $$('.cart-badge').forEach(function (el) { el.classList.toggle('visible', cart.item_count > 0); });
    });
  }
  function addToCart(btn, variantId, name) {
    if (!variantId || btn.classList.contains('loading')) return;
    btn.classList.add('loading');
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Impossibile aggiungere al carrello');
        toast('<b>' + esc(name || 'Prodotto') + '</b>&nbsp;aggiunto al carrello', true);
        return updateCount();
      })
      .catch(function (err) { toast(esc(err.message)); })
      .then(function () { btn.classList.remove('loading'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.add-to-cart[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn, btn.getAttribute('data-variant-id'), btn.getAttribute('data-product-name'));
  });
  $$('form.gog-product-form').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('.add-to-cart', f);
      if (btn) addToCart(btn, btn.getAttribute('data-variant-id'), btn.getAttribute('data-product-name'));
    });
  });

  /* Slider (Swiper) */
  var BP = {
    products: { 320: { slidesPerView: 1.2 }, 500: { slidesPerView: 1.5 }, 700: { slidesPerView: 2.5 }, 1024: { slidesPerView: 3.5 }, 1366: { slidesPerView: 4 } },
    authors: { 320: { slidesPerView: 1.5 }, 500: { slidesPerView: 2.5 }, 700: { slidesPerView: 3.5 }, 1024: { slidesPerView: 4.5 }, 1366: { slidesPerView: 6 } }
  };
  var swipers = [];
  function mount(el, opts) {
    if (!window.Swiper || !el || el.swiper) return null;
    el.classList.add('swiper');
    var s = new Swiper(el, opts);
    swipers.push(s);
    return s;
  }
  function initSliders() {
    $$('.full-slider, .home-edizioni .--slider').forEach(function (el) {
      mount(el, { slidesPerView: 1.2, grabCursor: true, watchOverflow: true, breakpoints: BP.products });
    });
    $$('.authors-slider').forEach(function (el) {
      mount(el, { slidesPerView: 1.5, grabCursor: true, watchOverflow: true, breakpoints: BP.authors });
    });
    $$('.filter-slider, .services-nav-mobile .slider-selected').forEach(function (el) {
      var sel = $('.selected', el), idx = 0;
      $$('.swiper-slide', el).forEach(function (s, i) { if (sel && s.contains(sel)) idx = i; });
      mount(el, { slidesPerView: 'auto', freeMode: true, grabCursor: true, initialSlide: idx });
    });
    var cover = $('.product-cover');
    if (cover) {
      var cs = mount(cover, { grabCursor: true, slidesPerView: 1 });
      var thumbs = $$('.product-gallery-items .--item');
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { cs && cs.slideTo(i); });
      });
      cs && cs.on('slideChange', function () {
        thumbs.forEach(function (t, i) { t.classList.toggle('selected', i === cs.activeIndex); });
      });
    }
  }

  /* Home: filtri per collana */
  $$('.home-edizioni').forEach(function (sec) {
    $$('.--filters .--item', sec).forEach(function (item) {
      item.addEventListener('click', function () {
        var slug = item.getAttribute('data-slug');
        $$('.--filters .--item', sec).forEach(function (i) { i.classList.toggle('selected', i === item); });
        $$('.--sliders .--slider', sec).forEach(function (s) {
          var on = s.getAttribute('data-slug') === slug;
          s.classList.toggle('selected', on);
          if (on && s.swiper) { s.swiper.update(); s.swiper.slideTo(0, 0); }
        });
      });
    });
  });

  /* Collezioni: pannello Filtra */
  $$('.products-filters-container').forEach(function (box) {
    var panel = $('.products-filters', box), bar = $('.products-filters-bar .button', box);
    bar && bar.addEventListener('click', function () {
      panel.classList.toggle('active');
      swipers.forEach(function (s) { s.update(); });
    });
    $$('.filter-slider', box).forEach(function (row) {
      $$('.filter-item', row).forEach(function (it) {
        it.addEventListener('click', function () {
          $$('.filter-item', row).forEach(function (i) { i.classList.toggle('selected', i === it); });
        });
      });
    });
    var submit = $('.submit-filters', box);
    submit && submit.addEventListener('click', function () {
      var c = $('[data-tax="collana"] .filter-item.selected', box), t = $('[data-tax="tema"] .filter-item.selected', box);
      var collana = c ? c.getAttribute('data-id') : '', tag = c ? c.getAttribute('data-tag') : '', tema = t ? t.getAttribute('data-id') : '';
      var url = root + 'collections/';
      if (tema && collana) url += tema + '/' + tag;
      else if (tema) url += tema;
      else if (collana) url += collana;
      else url += 'edizioni';
      window.location.href = url;
    });
  });

  /* Scheda prodotto */
  $$('.product-help .--item .--header').forEach(function (h) {
    h.addEventListener('click', function () { h.parentNode.classList.toggle('selected'); });
  });
  var mob = $('.product-actions-mob'), actions = $('.product-wrapper .product-actions');
  if (mob && actions && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var below = en.boundingClientRect.top > window.innerHeight;
        mob.classList.toggle('hidden', en.isIntersecting || !below);
      });
    }).observe(actions);
  }

  /* Newsletter: schede */
  $$('.newsletter-page').forEach(function (pg) {
    $$('.newsletter-nav .--item', pg).forEach(function (it) {
      it.addEventListener('click', function () {
        var tab = it.getAttribute('data-tab');
        $$('.newsletter-nav .--item', pg).forEach(function (i) { i.classList.toggle('selected', i === it); });
        $$('.newsletter-form [data-tab]', pg).forEach(function (s) { s.classList.toggle('selected', s.getAttribute('data-tab') === tab); });
      });
    });
  });

  /* Testo che si accende scorrendo (Chi siamo) */
  $$('.fade-text').forEach(function (el) {
    var text = el.textContent;
    el.setAttribute('aria-label', text.trim());
    el.innerHTML = text.split('').map(function (ch) { return '<span aria-hidden="true" style="opacity:.5">' + esc(ch) + '</span>'; }).join('');
    var spans = el.children, shown = -1;
    function update() {
      var r = el.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (window.innerHeight * 0.9 - r.top) / r.height));
      var n = Math.round(p * spans.length);
      if (n === shown) return;
      for (var i = 0; i < spans.length; i++) spans[i].style.opacity = i < n ? 1 : .5;
      shown = n;
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Cielo stellato (Geminga) */
  function Stars(canvas) {
    var ctx = canvas.getContext('2d'), speed = 5, count = 400, life = 5, stars = [], w, h;
    function size() { w = canvas.width = canvas.offsetWidth || canvas.parentNode.offsetWidth; h = canvas.height = canvas.offsetHeight || canvas.parentNode.offsetHeight; }
    function Star() { this.reset(); }
    Star.prototype.reset = function () { this.x = Math.random() * w - w / 2; this.y = Math.random() * h - h / 2; this.z = Math.random() * w; };
    Star.prototype.move = function () { this.z -= speed; if (this.z <= 0) this.reset(); };
    Star.prototype.show = function () {
      var d = w / this.z, x = this.x * d + w / 2, y = this.y * d + h / 2;
      var a = d > life ? 1.5 * (2 - d / life) : 1;
      if (a <= 0) return;
      ctx.globalAlpha = Math.min(1, a);
      ctx.beginPath(); ctx.fillStyle = '#000'; ctx.arc(x, y, Math.min(d, 4) * 0.5, 0, Math.PI * 2); ctx.fill();
      ctx.globalAlpha = 1;
    };
    size();
    for (var i = 0; i < count; i++) stars.push(new Star());
    window.addEventListener('resize', size);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (function loop() {
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h);
      stars.forEach(function (s) { if (!reduce) s.move(); s.show(); });
      if (!reduce) requestAnimationFrame(loop);
    })();
  }
  $$('canvas.stars').forEach(function (c) { try { Stars(c); } catch (e) {} });

  /* Avvio */
  if (window.Swiper) initSliders();
  else window.addEventListener('load', initSliders);
})();
